<template>
    <div class="m-contactCard" ref="contactcard" :class="isSlide ? '_active': ''">
        <div class="m-contactCard--sidebar" @click="clickSide()">
          <p>填寫表單</p><i class="icon-open"></i>
        </div>
        <p class="m-contactCard--content">謝謝你與家扶ＷaＷa一起探索森林，歡迎留下聯絡資料，當我們兒保出任務時，會邀請你一起來參與喔！</p>
            <h6 class="m-contactCard--title center" :class="hasSent ? '_show': '_hide'">表單送出成功！</h6>
            <form class="m-contactCard--form" action="" :class="hasSent ? '_hide': '_show'">
              <div class="form-group">
                  <input id="title" v-model="contact.title" :class="{error: errorClass($v.contact.title), valid: validClass($v.contact.title)}" @blur="$v.contact.title.$touch()">
                  <label for="title">姓名</label>
                  <p v-if="$v.contact.title.$error" class="error-message">必填</p>
              </div>
              <!--  Tel  -->
              <div class="form-group">
                  <input id="phone" v-model="contact.phone" :class="{valid: validClasswithNoRequired($v.contact.phone)}" @blur="$v.contact.phone.$touch()">
                  <label for="phone">電話</label>
                  <div>
                      <p v-if="$v.contact.phone.$model && $v.contact.phone.$error" class="error-message">格式錯誤</p>
                  </div>
              </div>
              <!--  Email  -->
              <div class="form-group">
                  <input id="email" v-model="contact.email" :class="{error: errorClass($v.contact.email), valid: validClass($v.contact.email)}" @blur="$v.contact.email.$touch()">
                  <label for="email">信箱</label>
                  <div v-if="$v.contact.email.$error">
                      <p v-if="!$v.contact.email.required" class="error-message">必填</p>
                      <p v-else-if="!$v.contact.email.email" class="error-message">格式錯誤</p>
                  </div>
              </div>
              <div class="form-group -row agree">
                  <input type="checkbox" id="edm" name="edm" v-model="contact.edm" value="confirmed" :class="{error: errorClass($v.contact.edm), valid: $v.contact.edm.$model}" @blur="$v.contact.edm.$touch()">
                  <label for="edm">同意收到家扶活動邀請，並同意本會依<span @click="clickPolicy()">個人資料保護法</span>之規定進行使用。</label>
                  <span v-if="$v.contact.edm.$error"><p v-if="!$v.contact.edm.$model" class="error-message">(必填)</p></span>
              </div>
            </form>
        <Btn type="green" class="m-contactCard--btn mx-auto" @click.native="submitForm()" :class="formLoading? '_disable' : ''" v-html="formLoading ? '送出中...': '確認送出'" v-if="!hasSent"></Btn>
    </div>
</template>

<script>
import axios from 'axios'
import Btn from './Btn.vue'
import qs from 'qs'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'Form',
  components: {
    Btn
  },
  data () {
    return {
      GOOGLE_SHEETS_SUBSCRIBE_CONTACT: 'AKfycbwZQqvYvQcLJoF75phUtHgMGy19g8hkt3QE_QqyOtljn65wmsFRjEPi2cx7EpIQdMA0PQ',
      formLoading: false,
      hasSent: false,
      isSlide: false,
      contact: {
        title: null,
        email: null,
        phone: null,
        edm: null
      }
    }
  },
  props: {
    id: String
  },
  validations: {
    contact: {
      title: {
        required
      },
      email: {
        required,
        email
      },
      phone: {},
      edm: {
        required
      }
    }
  },
  methods: {
    clickPolicy () {
      this.$parent.isPolicy = true
      this.$parent.isLightbox = !this.$parent.isLightbox
    },
    errorClass (formItem) {
      return formItem.$error
    },
    validClass (formItem) {
      return !formItem.$invalid && formItem.$model && formItem.$dirty
    },
    validClasswithNoRequired (formItem) {
      return !formItem.$invalid && formItem.$model
    },
    clearForm () {
      this.contact.title = null
      this.contact.email = null
      this.contact.phone = null
      this.$nextTick(() => {
        this.$v.contact.$reset()
      })
    },
    sendContact () {
      this.contact.id = this.id
      if (this.contact.edm) {
        this.contact.willing = '願意'
      } else {
        this.contact.willing = '不願意'
      }
      axios.post(`https://script.google.com/macros/s/${this.GOOGLE_SHEETS_SUBSCRIBE_CONTACT}/exec`, qs.stringify(this.contact))
        .then(() => {
          this.hasSent = true
          this.clearForm()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    submitForm () {
      this.$v.contact.$touch()
      if (!this.$v.contact.$invalid && this.$v.contact.edm.$model) {
        this.formLoading = true
        this.sendContact()
      }
    },
    clickSide () {
      this.isSlide = !this.isSlide
    }
  }
}
</script>

<style scoped lang="scss">
.m-contactCard{
  position: absolute;
  width: calc(100% - 40px);
  top: 00px;
  left: 20px;
  height: 450px;
  transform: translate3d(100%, 0px, 0px) translate3d(20px, 0, 0);
  border-radius: 30px;
  background: $form-bg;
  padding: 25px;
  z-index: map-get($z, "c-h");
  transition: .4s map-get($ease, 'IOquad');
  &--sidebar{
    position: absolute;
    top: 50px;
    left: -40px;
    height: 160px;
    width: 64px;
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
    padding: 20px 40px 20px 10px;
    background: $form-bg;
    i{
      display: block;
      margin-top: 5px;
      transition: .4s map-get($ease, 'IOquad');
      &:before{
        font-size: 12px;
      }
    }
  }
  .agree{
    label{
      line-height: 1.25;
    }
    p.error-message{
      top: 34px;
    }
  }
  &._active{
    transform: translate3d(25px, 0, 0);
    .m-contactCard--sidebar{
      i{
        transform: rotate(180deg);
      }
    }
  }
  @include respond-to(sm) {
    position: relative;
    top: auto;
    left: auto;
    width: 320px;
    height: 475px;
    transform: translate3d(0, 0, 0);
    margin-top: 50px;
    z-index: map-get($z, "c-l");
    &--sidebar{
      display: none;
      pointer-events: none;
    }
  }
  @include respond-to(md) {
    width: 350px;
  }
  @include respond-to('1200') {
    padding: 40px 25px;
    width: 480px;
    max-width: 34%;
  }
  @include respond-to(xl) {
    padding: 50px;
     height: 490px;
  }
  &--title{
     padding: 30px 0;
     transition: .4s ease-in-out;
     opacity: 0;
     pointer-events: none;
     &._show{
       opacity: 1;
       pointer-events: visible;
     }
  }
   &--form{
     transition: .4s ease-in-out;
     opacity: 0;
     pointer-events: none;
     &._show{
       opacity: 1;
       transform: translate3d(0, -60px, 0);
       pointer-events: visible;
     }
   }
   &--content{
     font-size: clamp(14px, 1.15vw, 16px);
   }
   &--btn{
     display: block;
     transform: translate3d(0, -60px, 0);
   }
}
</style>
